/* Generated File DO NOT EDIT. */
/* tslint:disable */
import * as Types from '../graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type WeeklyLogQueryVariables = Types.Exact<{
  offset: Types.Scalars['Int'];
}>;

export type WeeklyLogQuery = {
  __typename?: 'Query';
  needToAnswerWeeklyLog: boolean;
  weeklyLogDate: string;
  motivation: Array<{
    __typename?: 'Question';
    _id: string;
    title: string;
    description?: string | null;
    type: Types.QuestionType;
    inputMethod: Types.InputMethod;
    minValue?: number | null;
    maxValue?: number | null;
    minLabel?: string | null;
    maxLabel?: string | null;
    dropdownOptions?: Array<{ __typename?: 'DropdownOption'; option: string }> | null;
  }>;
  questions: Array<{
    __typename?: 'Question';
    _id: string;
    title: string;
    description?: string | null;
    type: Types.QuestionType;
    inputMethod: Types.InputMethod;
    minValue?: number | null;
    maxValue?: number | null;
    minLabel?: string | null;
    maxLabel?: string | null;
    dropdownOptions?: Array<{ __typename?: 'DropdownOption'; option: string }> | null;
  }>;
};

export type CreateWeeklyLogMutationVariables = Types.Exact<{
  input: Types.WeeklyLogInput;
}>;

export type CreateWeeklyLogMutation = {
  __typename?: 'Mutation';
  createWeeklyLog: { __typename?: 'WeeklyLog'; _id: string; userID: string; date: any; questions: Array<{ __typename?: 'WeeklyLogQuestion'; questionID: string; answer: string }> };
};

export const WeeklyLogDocument = gql`
  query weeklyLog($offset: Int!) {
    needToAnswerWeeklyLog(offset: $offset)
    weeklyLogDate(offset: $offset)
    motivation: questions(type: Motivation) {
      _id
      title
      description
      type
      inputMethod
      dropdownOptions {
        option
      }
      minValue
      maxValue
      minLabel
      maxLabel
    }
    questions(type: WeeklyLog) {
      _id
      title
      description
      type
      inputMethod
      dropdownOptions {
        option
      }
      minValue
      maxValue
      minLabel
      maxLabel
    }
  }
`;

/**
 * __useWeeklyLogQuery__
 *
 * To run a query within a React component, call `useWeeklyLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyLogQuery({
 *   variables: {
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useWeeklyLogQuery(baseOptions: Apollo.QueryHookOptions<WeeklyLogQuery, WeeklyLogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<WeeklyLogQuery, WeeklyLogQueryVariables>(WeeklyLogDocument, options);
}
export function useWeeklyLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeeklyLogQuery, WeeklyLogQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<WeeklyLogQuery, WeeklyLogQueryVariables>(WeeklyLogDocument, options);
}
export type WeeklyLogQueryHookResult = ReturnType<typeof useWeeklyLogQuery>;
export type WeeklyLogLazyQueryHookResult = ReturnType<typeof useWeeklyLogLazyQuery>;
export type WeeklyLogQueryResult = Apollo.QueryResult<WeeklyLogQuery, WeeklyLogQueryVariables>;
export const CreateWeeklyLogDocument = gql`
  mutation createWeeklyLog($input: WeeklyLogInput!) {
    createWeeklyLog(input: $input) {
      _id
      userID
      date
      questions {
        questionID
        answer
      }
    }
  }
`;
export type CreateWeeklyLogMutationFn = Apollo.MutationFunction<CreateWeeklyLogMutation, CreateWeeklyLogMutationVariables>;

/**
 * __useCreateWeeklyLogMutation__
 *
 * To run a mutation, you first call `useCreateWeeklyLogMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWeeklyLogMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWeeklyLogMutation, { data, loading, error }] = useCreateWeeklyLogMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWeeklyLogMutation(baseOptions?: Apollo.MutationHookOptions<CreateWeeklyLogMutation, CreateWeeklyLogMutationVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateWeeklyLogMutation, CreateWeeklyLogMutationVariables>(CreateWeeklyLogDocument, options);
}
export type CreateWeeklyLogMutationHookResult = ReturnType<typeof useCreateWeeklyLogMutation>;
export type CreateWeeklyLogMutationResult = Apollo.MutationResult<CreateWeeklyLogMutation>;
export type CreateWeeklyLogMutationOptions = Apollo.BaseMutationOptions<CreateWeeklyLogMutation, CreateWeeklyLogMutationVariables>;
